import { AddRegistryItemClickedProps } from '@apps/registry/common/components/Catalog/Catalog.telemetry.types';
import { EventUserStatus } from '@graphql/generated';
import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';

const category = 'shop';
const pagePrefix = 'newmarketing';

const telemObject = createTelemetryObject({
  pages: {
    eventPickerDialog: (membershipsCount: number) => ({
      category,
      pagePrefix,
      page: 'eventPickerDialog',
      extraPageInfo: {
        membershipsCount,
      },
    }),
  },
  actions: {
    eventPickerSelect: (args: { role: EventUserStatus; membershipsCount: number; eventId: string }) => ({
      category,
      page: 'eventPickerDialog',
      pagePrefix,
      action: 'Event',
      actionType: 'select',
      extraInfo: {
        ...args,
      },
    }),
    shopAuthenticate: ({ page, ...restArgs }: AddRegistryItemClickedProps) => ({
      category,
      page,
      pagePrefix,
      label: restArgs.method,
      action: 'ShopAuthenticate',
      extraInfo: {
        ...restArgs,
      },
    }),
  },
});

const { TelemetryProvider: PublicShopTelemetryProvider, useTelemetry: usePublicShopTelemetry } = createTelemetry(telemObject);

export { PublicShopTelemetryProvider, usePublicShopTelemetry };
